<template>
  <v-form ref="form" lazy-validation class="pa-4">
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field v-model="form.email" v-if="isBle" :label="$t('private_global_email')" readonly></v-text-field>
        <v-text-field v-model="form.label" v-else :label="$t('private_global_teletag')" readonly></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field v-model="form.keypad" :label="$t('private_global_keypad')" readonly></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field v-model="form.name" :label="$t('private_global_name')" :rules="[rules.required]" required></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field v-model="form.spot" :label="$t('private_global_spot')"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-textarea v-model="form.description" rows="4" style="padding-top:25px" counter="250" :label="$t('private_global_description')"></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs8>
        <vuetify-from-to-date-selector ref="fromToDateSelector" :lang-selected="langSelected" :prop-start="form.start" :prop-end="form.end" :allowSameStartEnd="false" :allowNullEnd="true" @on-dates-selected="datesSelected" />
      </v-flex>
      <v-flex xs4>
        <v-switch v-model="form.enabled" color="secondary" :label="$t('private_global_enabled')" hide-details class="right"></v-switch>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="submit()" :loading="isLoading">
        {{ $t('global_button_edit') }}
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import moment from 'moment';
import tenantService from '@/services/tenantService';
import VuetifyFromToDateSelector from '@/components/commons/VuetifyFromToDateSelector.vue';

export default {
  name: 'EditTenant',
  components: {
    [VuetifyFromToDateSelector.name]: VuetifyFromToDateSelector
  },

  computed: {
    isBle() {
      return this.form.email !== '';
    }
  },

  data() {
    return {
      rules: {
        required: value => !!value || this.$i18n.t('private_validation_required_name')
      },
      form: {
        ruleId: '',
        name: '',
        spot: '',
        description: '',
        label: '',
        start: '',
        end: '',
        email: '',
        enabled: null
      },
      isLoading: false,
      langSelected: store.state.langSelected,
      dateFormat: store.state.dateFormat
    };
  },

  methods: {
    datesSelected(params) {
      if (params.start) {
        this.form.start = params.start;
      }

      this.form.end = params.end;
    },
    reset() {
      this.$refs.fromToDateSelector.reset();
      Object.assign(this.form, {
        start: null,
        end: null,
        label: '',
        keypad: '',
        enabled: false,
        name: '',
        spot: '',
        email: '',
        description: '',
        ruleId: 0
      });
      this.isLoading = false;
    },
    setRule(rule) {
      this.$nextTick(() => {
        let end = moment(rule.end);
        if (end.year() === 2100) {
          end = null;
        } else {
          end = end.format('YYYY-MM-DD');
        }

        Object.assign(this.form, {
          start: moment(rule.start).format('YYYY-MM-DD'),
          end: end,
          label: rule.teletagLabel,
          keypad: rule.keypad,
          enabled: rule.enabled,
          name: rule.name,
          spot: rule.spot,
          email: rule.email,
          description: rule.description,
          ruleId: rule.id
        });
      });
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

        let params = {
          id: Number(this.form.ruleId),
          start: moment(this.form.start).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
          end: null,
          keypad: this.form.keypad,
          name: this.form.name,
          spot: this.form.spot,
          description: this.form.description,
          enabled: this.form.enabled
        };

        if (this.form.end) {
          params.end = moment(this.form.end).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
        }

        params.parkingId = Number(this.$route.params.id);

        let resp;
        if (this.isBle) {
          params.email = this.form.email;
          resp = await tenantService.edit(params);
          console.log('11');
          if (resp.error) {
            console.log('22');
            if (resp.status === 412) {
              EventBus.$emit(keys.eventOnShowNotification, {
                message: resp.data.error,
                type: 'error',
                doNotTranslate: true
              });
            } else {
              EventBus.$emit(keys.eventOnShowNotification, {
                message: this.$i18n.t('private_global_error'),
                type: 'error',
                doNotTranslate: true
              });
            }
            this.isLoading = false;
            console.log('33');
            return;
          }
        } else {
          params.label = this.form.label;
          resp = await tenantService.editTenantTag(params);
          if (resp.error) {
            if (resp.status === 412) {
              EventBus.$emit(keys.eventOnShowNotification, {
                message: resp.data.error,
                type: 'error',
                doNotTranslate: true
              });
            } else {
              EventBus.$emit(keys.eventOnShowNotification, {
                message: this.$i18n.t('private_global_error'),
                type: 'error',
                doNotTranslate: true
              });
            }
            this.isLoading = false;
            return;
          }
        }

        console.log('AA');
        EventBus.$emit(keys.eventOnShowNotification, {
          message: this.$i18n.t('private_owner_edit_success'),
          type: 'success',
          doNotTranslate: true
        });
        console.log('BB');

        // if (this.ownerTypeSelected === 'with-email') {
        //   if (this.isExistsEmail) {
        //     EventBus.$emit(keys.eventOnShowNotification, {
        //       message: this.$i18n.t('private_owner_create_success'),
        //       type: 'success',
        //       doNotTranslate: true
        //     });
        //   } else {
        //     EventBus.$emit(keys.eventOnShowNotification, {
        //       message: this.$i18n.t('private_owner_send_invitation_success'),
        //       type: 'success',
        //       doNotTranslate: true
        //     });

        //     EventBus.$emit(keys.eventOnTenantInvitationCreated);
        //   }
        // } else {
        //   EventBus.$emit(keys.eventOnShowNotification, {
        //     message: this.$i18n.t('private_owner_teletag_added_success'),
        //     type: 'success',
        //     doNotTranslate: true
        //   });
        // }

        this.reset();
        this.$emit('close');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/parking/EditTenant.vue